<div class="container-fluid h-100">
  <div class="styles-body h-100">
    <div class="panel panel-default body-space">
      <div class="panel-body content-body-pages">
        <div class="page-header">
          <div class="header-content">
            <div class="header-icon">
              <mat-icon>receipt_long</mat-icon>
            </div>
            <div class="header-text">
              <h1 class="page-title">{{ 'OpenFactors' | translate }}</h1>
              <p class="page-subtitle">{{ 'ManageAndViewAllOpenFactors' | translate }}</p>
            </div>
          </div>
          <div class="header-actions">
            <app-frontend-button
              (click)="refreshData()"
              [class]="'card-main'"
              [src]="'icons/refresh.svg'"
              [title]="'Refresh'">
            </app-frontend-button>
          </div>
        </div>
        <div class="branch-section mb-4">
          <div class="section-title">
            <mat-icon>store</mat-icon>
            <span>{{ 'SelectBranch' | translate }}</span>
          </div>
          <div class="branch-container">
            <div class="branch-grid">
              @if (branches && branches.length > 0) {
                @for (branch of branches; track branch.BusinessId) {
                  <div (click)="onBranchClick(branch)"
                       [ngClass]="{'selected': isBranchSelected(branch)}"
                       class="branch-item">
                    <div class="branch-icon">
                      <mat-icon>store</mat-icon>
                    </div>
                    <div class="branch-info">
                      <h4 class="branch-title">{{ branch.Title }}</h4>
                      @if (branch.Address) {
                        <p class="branch-address">{{ branch.Address }}</p>
                      }
                    </div>
                    <div class="branch-selection-indicator">
                      <img [src]="isBranchSelected(branch) ? '/icons/tick-circle.svg' : '/icons/circle.svg'"
                           alt="selection">
                    </div>
                  </div>
                }
              } @else {
                <div class="no-branches">
                  <mat-icon>store</mat-icon>
                  <p>{{ 'LoadingBranches' | translate }}</p>
                </div>
              }
            </div>
          </div>
        </div>

        @if (isLoading) {
          <div class="loading-container">
            <div class="loading-content">
              <mat-spinner diameter="60"></mat-spinner>
              <p class="loading-text">{{ 'LoadingFactors' | translate }}</p>
            </div>
          </div>
        }
        @if (!isLoading && filteredOrders.length === 0) {
          <div class="empty-container">
            <div class="empty-content">
              <div class="empty-icon">
                <mat-icon>receipt_long</mat-icon>
              </div>
              <h3 class="empty-title">{{ 'NoOpenFactorsFound' | translate }}</h3>
              <p class="empty-description">{{ 'ThereAreCurrentlyNoOpenFactorsToDisplay' | translate }}</p>
            </div>
          </div>
        }
        @if (!isLoading && filteredOrders.length > 0) {
          <div class="cards-grid">
            @for (factor of orders; track factor) {
              <div class="factor-card">
                <div class="card-content">
                  <div [ngClass]="getStatusClass(factor.Status)"
                       class="card-header">
                    <div class="header-info">
                      <div class="factor-id">
                        <span class="id-label">{{ 'FactorID' | translate }}</span>
                        <span class="id-value">#{{ factor.FactorId }}</span>
                      </div>
                      <div class="factor-date">
                        <mat-icon>schedule</mat-icon>
                        <span>{{ factor.CreateDate | time: 'YYYY/MM/DD HH:mm' }}</span>
                      </div>
                    </div>
                    <div class="status-container">
                      <div class="status-badge">
                        <mat-icon class="status-icon">{{ getStatusIcon(factor.Status) }}</mat-icon>
                        <span>{{ getStatusLabel(factor.Status) }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="card-section customer-section">
                    <div class="customer-details">
                      <div class="info-columns">
                        <div class="customer-column">
                          <div class="customer-info">
                            <div class="info-item">
                              <div class="info-icon">
                                <mat-icon>person</mat-icon>
                              </div>
                              <div class="info-content">
                                <span class="info-value">{{ factor.User?.FirstName }} {{ factor.User?.LastName }}</span>
                              </div>
                            </div>
                            <div class="info-item">
                              <div class="info-icon">
                                <mat-icon>phone</mat-icon>
                              </div>
                              <div class="info-content">
                                <span class="info-value">{{ factor.User?.MobileNumber }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="service-column">
                          <div class="service-info">
                            @if (factor.Space) {
                              <div class="info-item table-item">
                                <div class="info-icon">
                                  <mat-icon>table_restaurant</mat-icon>
                                </div>
                                <div class="info-content">
                                  <span class="info-label">{{ 'TableNumber' | translate }}</span>
                                  <span class="info-value table-value">{{ factor.Space.Title }}</span>
                                </div>
                              </div>
                            }
                            @if (factor.DeliveryMethod) {
                              <div class="info-item">
                                <div class="info-icon">
                                  @if (factor.DeliveryMethod.Type === 'OUTSIDE_DELIVER') {
                                    <mat-icon>delivery_dining</mat-icon>
                                  } @else {
                                    <mat-icon>restaurant</mat-icon>
                                  }
                                </div>
                                <div class="info-content">
                                  <span class="info-value">{{ factor.DeliveryMethod.Title }}</span>
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card-section order-section">
                    <div class="section-header">
                      <mat-icon>restaurant_menu</mat-icon>
                      <h6>{{ 'Products' | translate }} ({{ factor.FactorOrders?.length || 0 }})</h6>
                    </div>
                    <div class="order-items">
                      @for (order of factor.FactorOrders; track order) {
                        <div class="order-item">
                          <div (click)="toggleProductReady(order, !order.Order?.IsReady)"
                               [class.product-ready]="order.Order?.IsReady"
                               class="product-card">
                            <div class="product-header">
                              <div class="product-icon">
                                <mat-icon>restaurant</mat-icon>
                              </div>
                              <div class="product-info">
                                <div class="product-name">
                                  {{ order.Order?.ServicePrice?.Service?.Title }}
                                  <span class="quantity-badge">x{{ order.Order?.Count }}</span>
                                </div>
                                <div
                                  class="product-category">{{ order.Order?.ServicePrice?.Service?.Category?.Title }}
                                </div>
                              </div>
                              <div class="product-price">
                                {{ (order.Order?.ServicePrice?.Price * order.Order?.Count) | number }} تومان
                              </div>
                            </div>
                            @if (order.Order?.OrderServicePriceAdditives && order.Order.OrderServicePriceAdditives.length > 0) {
                              <div class="additives-section">
                                <div class="additives-label">
                                  <mat-icon>add_circle</mat-icon>
                                  <span>{{ 'Additives' | translate }}</span>
                                </div>
                                <div class="additives-list">
                                  @for (additive of order.Order.OrderServicePriceAdditives; track additive) {
                                    <div class="additive-item">
                                      <mat-icon>add</mat-icon>
                                      <span>{{ additive.ServicePriceAdditive?.Attribute?.Name }}</span>
                                    </div>
                                  }
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      }
                    </div>
                    <div class="order-total">
                      <div class="total-label">
                        <mat-icon>payments</mat-icon>
                        <span>{{ 'TotalSum' | translate }}</span>
                      </div>
                      <div class="total-amount">
                        {{ factor.PayablePrice | number }} تومان
                      </div>
                    </div>
                  </div>

                  @if (factor.UserAddress) {
                    <div class="card-section delivery-section">
                      <div class="section-header">
                        <mat-icon>location_on</mat-icon>
                        <h6>{{ 'DeliveryAddress' | translate }}</h6>
                      </div>
                      <div class="delivery-details">
                        <div class="delivery-address">{{ factor.UserAddress.Detail }}</div>
                      </div>
                    </div>
                  }
                </div>
                <div class="card-actions">
                  <div class="status-change-container">
                    <app-frontend-button
                      (click)="changeStatus(factor)"
                      [class]="factor.Status === 'DELIVERED' || factor.Status === 'CANCELED' || factor.Status === 'CANCELED_BY_SYSTEM' ? 'card-disabled' : 'card-main'"
                      [src]="'icons/edit.svg'"
                      [title]="factor.Status === 'DELIVERED' || factor.Status === 'CANCELED' || factor.Status === 'CANCELED_BY_SYSTEM' ? 'وضعیت قابل تغییر نیست' : 'ChangeStatus'">
                    </app-frontend-button>
                  </div>
                  <app-frontend-button
                    (click)="addNewItem(factor)"
                    [class]="'card-secondary'"
                    [src]="'icons/add.svg'"
                    [title]="'Insert'">
                  </app-frontend-button>
                </div>
              </div>
            }
          </div>

          @if (tableProperties.pageLength > 0) {
            <div class="pagination-container">
              <mat-paginator
                (page)="pageChanged($event)"
                [length]="tableProperties.pageLength"
                [pageIndex]="tableProperties.offset"
                [pageSizeOptions]="tableProperties.limitOptions"
                [pageSize]="tableProperties.limit"
                [showFirstLastButtons]="true">
              </mat-paginator>
            </div>
          }
        }
        @if (showStatusDropdown && selectedFactor) {
          <div (click)="closeStatusDropdown()"
               class="status-dropdown-backdrop"></div>
          <div (click)="$event.stopPropagation()"
               class="status-dropdown">
            <div class="dropdown-header">
              <span>تغییر وضعیت</span>
              <button (click)="closeStatusDropdown()"
                      class="close-btn">
                <mat-icon>close</mat-icon>
              </button>
            </div>
            <div class="dropdown-content">
              @if (isLoading) {
                <div class="loading-status">
                  <mat-spinner diameter="20"></mat-spinner>
                  <span>در حال بروزرسانی...</span>
                </div>
              } @else {
                <div (click)="$event.stopPropagation()"
                     class="time-input-section">
                  <label class="time-input-label">
                    <mat-icon>schedule</mat-icon>
                    <span>زمان تقریبی آماده‌سازی (دقیقه)</span>
                  </label>
                  <input
                    (click)="$event.stopPropagation()"
                    (focus)="$event.stopPropagation()"
                    [(ngModel)]="remainedTimeToDeliver"
                    class="time-input"
                    min="0"
                    placeholder="مثلاً 30"
                    step="1"
                    type="number">
                </div>
                @for (status of availableStatuses; track status.value) {
                  <div (click)="updateFactorStatus(status.value)"
                       [class.current-status]="selectedFactor?.Status === status.value"
                       class="status-option">
                    <mat-icon>{{ status.icon }}</mat-icon>
                    <span>{{ status.label }}</span>
                    @if (selectedFactor?.Status === status.value) {
                      <mat-icon class="current-indicator">check_circle</mat-icon>
                    }
                  </div>
                }
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
